// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"438":"c2eca16470e0cb07","635":"dc1570b4bf513f57"}[chunkId] + ".js";
};